import { supabase } from '@/services/supabaseClient'

export const ADMIN_LOGIN_PATH = '/login'
export const TEACHER_LOGIN_PATH = '/login'
export const ADMIN_DASHBOARD_PATH = '/dashboard'
export const TEACHER_DASHBOARD_PATH = '/teacher-dashboard'
export const TEACHER_RESULT_ENTRY_PATH = '/result-entry'
export const ADMIN_RESULT_ENTRY_PATH = '/result-entry-admin'

export interface CollegeUser {
  college_id: number
  college_name: string
  college_eiin: number | string
  admin_email: string
  college_logo_url?: string
  college_mobile?: string
  college_address?: string
  website?: string
  email?: string
  principal_name?: string
  college_name_en?: string
  college_address_en?: string
  principal_name_en?: string
}

export function normalizeEmail(email: string | null | undefined): string {
  return (email ?? '').trim().toLowerCase()
}

// Any authenticated user in Supabase Auth is authorized
export function isAdminEmail(email: string | null | undefined): boolean {
  return Boolean(email && email.trim().length > 0)
}

/** Fetch college details & EIIN for the logged-in admin email to enforce college isolation */
export async function getCollegeByAdminEmail(email: string | null | undefined): Promise<CollegeUser | null> {
  const normEmail = normalizeEmail(email)
  if (!normEmail) return null

  try {
    const { data, error } = await supabase
      .from('college_user')
      .select('*')
      .ilike('admin_email', normEmail)
      .limit(1)
      .maybeSingle()

    if (error || !data) {
      console.warn(`No college_user record found for admin email: ${normEmail}`)
      return null
    }

    return data as CollegeUser
  } catch (err) {
    console.error('getCollegeByAdminEmail error:', err)
    return null
  }
}

export function getPostLoginRedirect(_email: string | null | undefined, requestedRedirect: string | null): string {
  const redirect = (requestedRedirect ?? '').trim()
  if (redirect && redirect !== ADMIN_LOGIN_PATH && redirect !== TEACHER_LOGIN_PATH) {
    return redirect
  }
  return ADMIN_DASHBOARD_PATH
}
